import { z } from "zod"

// Server tag filter options
export const serverPvpTypes = ['PvP', 'PvE Only', 'Consensual PvP', 'Felucca Only'] as const
export const serverMapTypes = ['Original', 'Custom', 'Hybrid'] as const
export const serverEmulators = ['ServUO', 'RunUO', 'ModernUO', 'Sphere', 'POL', 'Broadsword'] as const
export const serverRegions = ['NA', 'EU', 'BR', 'RU', 'Global'] as const
export const serverLanguages = ['English', 'Portuguese', 'German', 'Russian', 'Spanish', 'Italian', 'Turkish', 'Czech'] as const
export const serverEras = ['T2A', 'Renaissance', 'AoS', 'Custom'] as const

// Server tag data keyed by slug
export const serverTags: Record<string, {
	skillCap?: number
	skillFloor?: number
	mapType?: string
	pvpType?: string
	emulator?: string
	region?: string
	language?: string
	era?: string
}> = {
	'uo-sagas':          { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'requiem-rpg':       { skillCap: 700, mapType: 'Custom', pvpType: 'Consensual PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'imperial-shard':    { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'BR', language: 'Portuguese', era: 'Renaissance' },
	'official-uo':       { skillCap: 720, mapType: 'Original', pvpType: 'PvP', emulator: 'Broadsword', region: 'Global', language: 'English', era: 'AoS' },
	'uo-outlands':       { skillCap: 720, skillFloor: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-alive':          { skillCap: 720, mapType: 'Custom', pvpType: 'PvE Only', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'uo-forever':        { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'Renaissance' },
	'uo-unchained':      { skillCap: 720, mapType: 'Custom', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'uo-renaissance':    { skillCap: 700, mapType: 'Original', pvpType: 'Felucca Only', emulator: 'RunUO', region: 'NA', language: 'English', era: 'Renaissance' },
	'aa-siege-perilous': { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-lost-lands':     { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-1998':           { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-second-age':     { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-gamers':         { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-shadow-age-reborn': { skillCap: 720, mapType: 'Original', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'AoS' },
	'insane-uo':         { skillCap: 720, mapType: 'Original', pvpType: 'Consensual PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'AoS' },
	'uo-felucca':        { skillCap: 700, mapType: 'Custom', pvpType: 'Felucca Only', emulator: 'ServUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-enigma':         { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uog-demise':        { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'endor-revived':     { skillCap: 0, mapType: 'Custom', pvpType: 'PvP', emulator: 'RunUO', region: 'EU', language: 'English', era: 'Custom' },
	'uo-evolution':      { skillCap: 0, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'Custom' },
	'uorpg':             { skillCap: 700, mapType: 'Original', pvpType: 'Consensual PvP', emulator: 'RunUO', region: 'RU', language: 'Russian', era: 'T2A' },
	'uo-excelsior':      { skillCap: 0, mapType: 'Custom', pvpType: 'Consensual PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'pyramid-uo':        { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'EU', language: 'Turkish', era: 'Renaissance' },
	'uo-eventine':       { skillCap: 0, mapType: 'Custom', pvpType: 'PvE Only', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'arth-uo':           { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'the-crossroads':    { skillCap: 700, mapType: 'Original', pvpType: 'Consensual PvP', emulator: 'ModernUO', region: 'NA', language: 'English', era: 'Custom' },
	'uo-eclipse':        { skillCap: 700, mapType: 'Custom', pvpType: 'PvE Only', emulator: 'ServUO', region: 'NA', language: 'English', era: 'T2A' },
	'beyond-sosaria':    { skillCap: 0, mapType: 'Original', pvpType: 'PvE Only', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'alathair':          { skillCap: 700, mapType: 'Custom', pvpType: 'Consensual PvP', emulator: 'Sphere', region: 'EU', language: 'German', era: 'Custom' },
	'classic-dungeon-shard': { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'BR', language: 'Portuguese', era: 'T2A' },
	'tides-of-power':    { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Renaissance' },
	'ultima-alianza':    { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'EU', language: 'Spanish', era: 'Custom' },
	'uodreams':          { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'EU', language: 'Italian', era: 'Custom' },
	'new-renaissance':   { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Renaissance' },
	'uo-antares':        { skillCap: 0, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'RU', language: 'Russian', era: 'Custom' },
	'the-miracle':       { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'RunUO', region: 'EU', language: 'Italian', era: 'Custom' },
	'nightuo':           { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'EU', language: 'Turkish', era: 'Renaissance' },
	'pvp-alfa':          { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'RU', language: 'Russian', era: 'Renaissance' },
	'legends-of-sosaria': { skillCap: 0, mapType: 'Custom', pvpType: 'PvE Only', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'pandora-uo':        { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'Custom' },
	'vetus-mundus':      { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'RunUO', region: 'EU', language: 'German', era: 'Custom' },
	'the-last-kingdom':  { skillCap: 0, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'NA', language: 'English', era: 'Custom' },
	'midkemia':          { skillCap: 700, mapType: 'Custom', pvpType: 'PvE Only', emulator: 'RunUO', region: 'EU', language: 'Czech', era: 'Custom' },
	'uo-phoenix':        { skillCap: 700, mapType: 'Original', pvpType: 'Consensual PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-strange-earth':  { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'regisfall':         { skillCap: 700, mapType: 'Custom', pvpType: 'Consensual PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'Custom' },
	'old-paradise':      { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'RunUO', region: 'RU', language: 'Russian', era: 'Custom' },
	'mythicuo':          { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'T2A' },
	'uo-resurgence':     { skillCap: 0, mapType: 'Custom', pvpType: 'PvP', emulator: 'RunUO', region: 'NA', language: 'English', era: 'Custom' },
	'horizon':           { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'ServUO', region: 'NA', language: 'English', era: 'Custom' },
	'sigena':            { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'POL', region: 'EU', language: 'German', era: 'Custom' },
	'olmer':             { skillCap: 700, mapType: 'Custom', pvpType: 'PvP', emulator: 'Sphere', region: 'RU', language: 'Russian', era: 'Custom' },
	'the-darkside':      { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'NA', language: 'English', era: 'Custom' },
	'ultima-online-xl':  { skillCap: 700, mapType: 'Original', pvpType: 'PvP', emulator: 'Sphere', region: 'RU', language: 'Russian', era: 'Custom' },
}

export const serverInfo = [
    {
        name: "UO Sagas",
        slug: "uo-sagas",
        website: "https://uosagas.com/",
        logo: "/images/logos/server-uo-sagas.png",
        shards: [
            'UO Sagas'
        ],
        establishedAt: new Date("May 17, 2025"),
        description: "Welcome to UO Sagas - a challenging free-to-play adventure crafted by veterans of Defiance UO. Experience a complete new world with classic feel but unique gameplay. Explore dangerous dungeons, defeat epic bosses, build wealth, and forge alliances in this fresh chapter of Ultima Online.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "AnimalTaming",
            "Archery",
            "ArmsLore",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Fencing",
            "Fishing",
            "Healing",
            "Herding",
            "Hiding",
            "Inscribe",
            "ItemID",
            "Lockpicking",
            "Lumberjacking",
            "Mace Fighting",
            "Magery",
            "Meditation",
            "Mining",
            "Musicianship",
            "Parry",
            "Peacemaking",
            "Poisoning",
            "Provocation",
            "RemoveTrap",
            "Resisting",
            "Skinning",
            "Snooping",
            "SpiritSpeak",
            "Stealing",
            "Stealth",
            "Swords",
            "Tactics",
            "Tailoring",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Wrestling",
        ]
    },
    {
        name: "Requiem RPG",
        slug: "requiem-rpg",
        website: "https://requiemrpg.com/",
        discord: "https://discord.gg/13thrones",
        logo: "/images/logos/server-requiem.png",
        shards: [
            'Requiem'
        ],
        skills: [
            "Alchemy",
            "Anatomy",
            "WorldLore",
            "TwoHandedTactics",
            "Parry",
            "Skinning",
            "Blacksmith",
            "Artisanry",
            "Agriculture",
            "Carpentry",
            "Axes",
            "Cooking",
            "Perception",
            "Firearms",
            "ArcaneIncantation",
            "Allopathy",
            "OffHand",
            "Hiding",
            "ArcaneLinguistics",
            "Lockpicking",
            "GeneralArcana",
            "MagicResist",
            "Tactics",
            "Subterfuge",
            "Poisoning",
            "Archery",
            "Stealing",
            "Tailoring",
            "Engineering",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Horticulture",
            "Geology",
            "Diabolism",
            "Finesse",
            "Divine",
            "Raging",
            "Archmagic",
            "Paganistic",
            "Polearms",
            "Throwing",
        ],
        establishedAt: new Date("June 20, 2025"),
        description: "Requiem is one of the last true enforced role-playing shards left in the Ultima Online player-ran community. Versions and instances of Requiem have been operational for nearly ten years. Over our long history, we have cultivated a strong core community of veteran role-players, talented map makers, proficient programmers and experienced game masters.",
    },
    {
        name: "Imperial Shard",
        slug: "imperial-shard",
        website: "https://imperialshard.com.br/",
        logo: "/images/logos/server-imperial-shard.png",
        shards: [
            'Imperial Shard'
        ],
        establishedAt: new Date("January 1, 2025"),
        description: "Imperial Shard is a free-to-play Brazilian Ultima Online server.",
    },
    {
        name: "Official UO",
        slug: "official-uo",
        website: "https://uo.com",
        logo: "/images/logos/server-uo-broadsword.png",
        shards: [
            'Oceania',
            'Sakura',
            'Mugen',
            'Wakoku',
            'Formosa',
            'Izumo',
            'Yamato',
            'Asuka',
            'Balhae',
            'Europa',
            'Drachenfels',
            'Legends',
            'Atlantic',
            'Lake Superior',
            'Great Lakes',
            'Chesapeake',
            'Catskills',
            'Siege Perilous',
            'Origin',
            'Pacific',
            'Sonoma',
            'Lake Austin',
            'Baja',
            'Napa Valley',
            'New Legacy',
            //'Test Center'
        ],
        establishedAt: new Date("September 24, 1997"),
        description: "To all of those for whom it's the first time you are hearing of Britannia, we bid you welcome, and to any of those who have visited in Ultima Online’s long history or who have seen Britannia through any of the other Ultima games, we bid you welcome home. There’s no place like it, or so we’re always told.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "SpellWeaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: "UO Outlands",
        slug: "uo-outlands",
        shards: [
            'Outlands',
        ],
        website: "https://uooutlands.com",
        logo: "/images/logos/server-uo-outlands.png",
        establishedAt: new Date("October 1, 2018"),
        description: "UO Outlands is a free-to-play Ultima Online shard loosely set in the T2A era which launched in October of 2018. Our mission from the onset has been to create a version of Ultima Online which enhances every aspect of gameplay, creating a shard which we believe emulates how Ultima Online should have always been had it stayed the course.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Arcane",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            "Necromancy",
            "Focus",
            "Chivalry",
            // "Bushido",
            // "Ninjitsu",
            // "SpellWeaving",
        ]
    },
    {
        name: "UO Alive",
        slug: "uo-alive",
        shards: [
            'Alive',
        ],
        logo: "/images/logos/server-uo-alive.png",
        establishedAt: new Date("January 1, 2017"),
        website: "https://uoalive.com",
        description: "UO Alive is a free-to-play Ultima Online shard that launched in 2016. It is a custom map with custom content and a focus on PvE.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "SpellWeaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: "UO Forever",
        slug: "uo-forever",
        shards: [
            'Forever',
            'Overdrive',
        ],
        establishedAt: new Date("January 18, 2013"),
        logo: "/images/logos/server-uo-forever.png",
        website: "https://uoforever.com",
        description: "On January 18th, 2013, Ultima Online Forever was launched providing players from around the globe a free shard that pays homage to the Renaissance era of the original Ultima Online with all of its nostalgia, while always building on and expanding the game to offer new and exclusive content.",
        skills: [
"Alchemy",
"Anatomy",
"AnimalLore",
"ItemID",
"ArmsLore",
"Parry",
"Begging",
"Blacksmith",
"Fletching",
"Peacemaking",
"Camping",
"Carpentry",
"Cartography",
"Cooking",
"DetectHidden",
"Discordance",
"EvalInt",
"Healing",
"Fishing",
"Forensics",
"Herding",
"Hiding",
"Provocation",
"Inscribe",
"Lockpicking",
"Magery",
"MagicResist",
"Tactics",
"Snooping",
"Musicianship",
"Poisoning",
"Archery",
"SpiritSpeak",
"Stealing",
"Tailoring",
"AnimalTaming",
"TasteID",
"Tinkering",
"Tracking",
"Veterinary",
"Swords",
"Macing",
"Fencing",
"Wrestling",
"Lumberjacking",
"Mining",
"Meditation",
"Stealth",
"RemoveTrap",
"Necromancy",
"Focus",
"Chivalry",
"Bushido",
"Ninjitsu",
"SpellWeaving",
"Mysticism",
"Imbuing",
"Throwing",
            
        ]
    },
    {
        name: "UO Unchained",
        slug: "uo-unchained",
        shards: [
            'Unchained',
        ],
        establishedAt: new Date("March 18, 2023"),
        logo: "/images/logos/server-uo-unchained.png",
        website: "https://play-uo.com",
        description: "UO Unchained is a free-to-play Ultima Online shard that launched in 2020. It is a custom map with custom content and a focus on PvE.",
        skills: [
            "Alchemy",
            "Anatomy",
            "Animal Lore",
            "Item Identification",
            "Arms Lore",
            "Parrying",
            "Scavenging",
            "Blacksmithing",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "Detecting Hidden",
            "Discordance",
            "Eval Intelligence",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscription",
            "Lock Picking",
            "Magery",
            "Resisting Spells",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "Spirit Speak",
            "Stealing",
            "Tailoring",
            "Animal Taming",
            "Taste Identification",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swordsmanship",
            "Mace Fighting",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "Remove Trap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "Spellweaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: "UO Renaissance",
        slug: "uo-renaissance",
        establishedAt: new Date("September 01, 2012"),
        shards: [
            'Renaissance',
        ],
        logo: "/images/logos/server-uo-renaissance.png",
        website: "https://uorenaissance.com/",
        description: "UO:Renaissance is an Ultima Online free-shard, based on Renaissance era mechanics, without the influences of Trammel. Designed and operated by passionate PvM and PvP experienced staff, that do not play here, this recreation aims to perfect what we all loved about Ultima Online before its decline. A highly immersive game with seemingly limitless possibilities coupled with risk vs reward, this world is what the players make of it. Offering an extensive crafting system with the best free shard economy, PvP mechanics with more templates than you'll have the time for and PvM with more challenge and data than ever before.  This is the shard to play on if you want to truly enjoy Ultima Online.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
    },
    {
        name: "Angel Island",
        slug: "uo-angel-island",
        shards: [
            'Angel Island 2016',
            'Angel Island 2024',
            'Siege Perilous 2024',
            'Mortalis',
            //'AI Test Center 2016',
            //'Player Tribute',
        ],
        logo: "/images/logos/server-ai-siege-perilous.png",
        website: "https://game-master.net",
        description: "The launcher will install both Angel Island and Siege Perilous all at once. Both shards are available through the server listing once logged in to the game.",
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
    },
    {
        name: 'UO Lost Lands',
        slug: 'uo-lost-lands',
        shards: [
            'Lost Lands',
        ],
        logo: '/images/logos/server-lostlands.png',
        website: 'https://uolostlands.com',
        description: 'Set during The Second Age of Ultima Online - Lost Lands is an unrestricted, OSI accurate online game full of risk, reward, and endless adventure. Enjoy the freedom of customising your own skillset to become a powerful mage, merciless fighter, crafter, tamer, treasure hunter, or perhaps a dishonorable thief or murderer. Stake your claim of land and build yourself a home to live in, from small houses to grand castles in an open sandbox world.',
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
    },
    {
        name: 'UOG Demise',
        slug: 'uog-demise',
        establishedAt: new Date("September 01, 2004"),
        shards: [
            'Demise'
        ],
        logo: '/images/logos/server-uog-demise.png',
        website: 'https://www.uogdemise.com/',
        description: `Demise began its life in September '04 and, as part of the UOGamers family, quickly grew to a popular shard. Formerly the flagship development shard of the RunUO Software Team, last released publicly in 2013, it has since undergone a paradigm shift exceeding all expectations as a standalone shard.

        Over the years, Demise has built one of the strongest, most supportive gameplay communities, alongside an unparalleled level of reliability and uptime. With so much love and fondness for Demise, from both players and the staff team, the future looks bright!
        
        Demise strives to retain the core gameplay of a Mondain's Legacy era shard, with a few added extras. Come and explore the endless possibilities, from dungeon Doom to crafting to PvP to Peerless and much more! Join our community to keep up with the latest news, make new friends and you will no doubt feel right at home. With an established staff team and year-round events, entertainment is guaranteed!`
        
    },
    {
        name: 'UO Enigma',
        slug: 'uo-enigma',
        establishedAt: new Date("November 9, 2024"),
        shards: [
            'Enigma'
        ],
        logo: '/images/logos/server-uo-enigma.png',
        website: 'https://uo-enigma.com',
        description: `Why Play on UO Enigma?

        UO:Enigma is a true passion project, refined over years of dedication.
        Mid-sized, fully custom map with an exciting Felucca ruleset.
        Nostalgic, yet brimming with fresh and unique content.`,
        skills: [
            "Alchemy",
            "Anatomy",
            "Animal Lore",
            "Masonry",
            "Arms Lore",
            "Parrying",
            "Begging",
            "Blacksmithing",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "Detecting Hidden",
            "Discordance",
            "Eval Intelligence",
            "Healing",
            "Fishing",
            "Skinning",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscription",
            "Lock Picking",
            "Magery",
            "Resisting Spells",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "Spirit Speak",
            "Stealing",
            "Tailoring",
            "Animal Taming",
            "Taste Identification",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swordsmanship",
            "Mace Fighting",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "Remove Trap",
            "Necromancy",
            "Focus",
            "Chivalry",
            "Bushido",
            "Ninjitsu",
            "Spellweaving",
            "Mysticism",
            "Imbuing",
            "Throwing",
        ]
    },
    {
        name: 'UO Felucca',
        slug: 'uo-felucca',
        establishedAt: new Date("December 16, 2022"),
        shards: [
            'Felucca'
        ],
        logo: '/images/logos/server-uo-felucca.png',
        website: 'https://uofelucca.net/',
        description: `Explore the world of Felucca, a custom free-to-play Ultima Online shard that blends pre-AoS mechanics for exhilarating PvP with enhanced PvM and crafting experiences for additional custom content. What will you become? Forge your fantasy!`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'Insane UO',
        slug: 'insane-uo',
        establishedAt: new Date("December 16, 2022"),
        shards: [
            'InsaneUO'
        ],
        logo: '/images/logos/server-insane-uo.png',
        website: 'https://insaneuo.com/',
        description: `Insane UO takes modern UO and makes it crazy! Crazy awesome, that is! Our focus is to get you up and running quickly so you can enjoy the content you love. And more than that, we want to reward you for doing the content you enjoy most, whether it’s Champion Spawns, Peerless bosses, Crafting, or just hunting monsters! While this is primarily a PvM/PvE server, consensual PvP is allowed via Guild wars and the arenas!`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'UO Shadow Age Reborn',
        slug: 'uo-shadow-age-reborn',
        establishedAt: new Date("December 12, 2023"),
        shards: [
            'Shadow Age'
        ],
        logo: '/images/logos/server-shadow-age-reborn.png',
        website: 'https://shadowagereborn.com/',
        description: `A massively rebuilt Age of Shadows experience, UO Shadow Age returns once again!  Originally released 10 years ago and became one of the largest AOS freeshards out there. We've rebuilt and modernized the original Felucca landmass, including transparent water (including ocean), improved the looks of nearly all dungeons and many towns, built dozens of new POI's all over the overworld of Sosaria, removed some underused cities/land areas, and rebuilt old dungeons (like wrong, fire) entirely and enhanced old favorites (like ice and covetous) again.`,
        skills: [
"Alchemy",
"Anatomy",
"AnimalLore",
"ItemID",
"ArmsLore",
"Parry",
"Begging",
"Blacksmith",
"Fletching",
"Peacemaking",
"Camping",
"Carpentry",
"Cartography",
"Cooking",
"DetectHidden",
"Discordance",
"EvalInt",
"Healing",
"Fishing",
"Forensics",
"Herding",
"Hiding",
"Provocation",
"Inscribe",
"Lockpicking",
"Magery",
"MagicResist",
"Tactics",
"Snooping",
"Musicianship",
"Poisoning",
"Archery",
"SpiritSpeak",
"Stealing",
"Tailoring",
"AnimalTaming",
"TasteID",
"Tinkering",
"Tracking",
"Veterinary",
"Swords",
"Macing",
"Fencing",
"Wrestling",
"Lumberjacking",
"Mining",
"Meditation",
"Stealth",
"RemoveTrap",
"Necromancy",
"Focus",
"Chivalry",
"Bushido",
"Ninjitsu",
"SpellWeaving",
"Mysticism",
"Imbuing",
"Throwing",
            
        ]
     },
     {
        name: 'UO Gamers',
        slug: 'uo-gamers',
        establishedAt: new Date("Jan 1, 1999"),
        shards: [
            'UO Gamers'
        ],
        logo: '/images/logos/server-uo-gamers.png',
        website: 'https://uogamers.com/',
        description: `Launched in 1999, before RunUO existed, UOGamers has been the standard barer for Ultima Online servers. WIth a peak usercount of more than 15,000 online users, we are foundational to the Ultima Online community.`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'UO Second Age',
        slug: 'uo-second-age',
        establishedAt: new Date("Jan 1, 2007"),
        shards: [
            'Second Age'
        ],
        logo: '/images/logos/server-uo-second-age.png',
        website: 'https://www.uosecondage.com/',
        description: `Founded in 2007, Second Age has established itself as the preeminent T2A era free shard in operation. With our mission being to provide an accurate representation of Ultima Online, the way it was in 1999, our staff does not endorse any particular style of play on Second Age`,
        skills: [
"Alchemy",
"Anatomy",
"AnimalLore",
"ItemID",
"ArmsLore",
"Parry",
"Begging",
"Blacksmith",
"Fletching",
"Peacemaking",
"Camping",
"Carpentry",
"Cartography",
"Cooking",
"DetectHidden",
"Discordance",
"EvalInt",
"Healing",
"Fishing",
"Forensics",
"Herding",
"Hiding",
"Provocation",
"Inscribe",
"Lockpicking",
"Magery",
"MagicResist",
"Tactics",
"Snooping",
"Musicianship",
"Poisoning",
"Archery",
"SpiritSpeak",
"Stealing",
"Tailoring",
"AnimalTaming",
"TasteID",
"Tinkering",
"Tracking",
"Veterinary",
"Swords",
"Macing",
"Fencing",
"Wrestling",
"Lumberjacking",
"Mining",
"Meditation",
"Stealth",
"RemoveTrap",

        ]
     },
     {
        name: 'UO 1998',
        slug: 'uo-1998',
        establishedAt: new Date("Jan 24, 2025"),
        shards: [
            'UO 1998'
        ],
        logo: '/images/logos/server-uo-1998.png',
        website: 'https://www.uo1998.com/',
        description: `UO: 1998 is a faithful recreation of the original Ultima Online experience, using the original 1.25.35 client from 1998. We've meticulously crafted a server that reflects the era-accurate gameplay based on code from the UO Demo, before the introduction of T2A.

        This is a museum of the original Ultima Online, untouched by modern changes. No modern clients or assistants will work here, offering a truly authentic experience for those who want to relive the golden age of UO.`,
        skills: [
            "Alchemy",
            "Anatomy",
            "AnimalLore",
            "ItemID",
            "ArmsLore",
            "Parry",
            "Begging",
            "Blacksmith",
            "Fletching",
            "Peacemaking",
            "Camping",
            "Carpentry",
            "Cartography",
            "Cooking",
            "DetectHidden",
            "Discordance",
            "EvalInt",
            "Healing",
            "Fishing",
            "Forensics",
            "Herding",
            "Hiding",
            "Provocation",
            "Inscribe",
            "Lockpicking",
            "Magery",
            "MagicResist",
            "Tactics",
            "Snooping",
            "Musicianship",
            "Poisoning",
            "Archery",
            "SpiritSpeak",
            "Stealing",
            "Tailoring",
            "AnimalTaming",
            "TasteID",
            "Tinkering",
            "Tracking",
            "Veterinary",
            "Swords",
            "Macing",
            "Fencing",
            "Wrestling",
            "Lumberjacking",
            "Mining",
            "Meditation",
            "Stealth",
            "RemoveTrap",
            
                    ]
     },
     {
        name: 'Endor Revived',
        slug: 'endor-revived',
        establishedAt: new Date("October 5, 2023"),
        shards: [
            'Endor Revived'
        ],
        logo: '/images/logos/server-endor-revived.png',
        website: 'https://www.endor-revived.com/',
        description: `Endor is a popular MMORPG based on the Ultima Online. It has a long tradition of game development and player support dating back to the early 2000s a legacy longer than many famous titles such as World of Warcraft. Experience/Level system, custom map, dozens of cities, hundreds of dungeons and quests. 5.10.2023 the shard was restarted from scratch and has been modernized with a huge update to classes, map, dungeons, systems and much more.

Endor is a classic sandbox game - you can literally do anything you want in this vast and open fantasy world. Want to be a famous dungeon conqueror? A merciless player-killer? Own a house and a boat? Or just chill in one of the taverns and chat with other players? You can do it all on Endor. Only your skill and determination will make the difference between success and failure.

Endor is unique in the Ultima Online scene for its experience and class-based system. You can choose from 13 different classes and make your own way through this beautiful and rich world. Defeat enemies, gain experience, advance to higher levels, collect better equipment and challenge stronger foes. It's a classic, time-tested RPG play style that works and doesn’t need to be changed. Each character also has a set of core skills that increase in power as you level up and can be trained by the character.

However, Endor has evolved throughout its existence, allowing it to refine its core features and expand its content to a level that rivals most modern MMORPGs.

Endor's core features are still growing, we are not done yet!

Endor offers all this and more. 5/10/2023 the shard was restarted from scratch and has been modernized with a huge update to classes, map, dungeons, systems and much more, so everyone can start on the same level. And the best part? Endor is free, with experienced staff always ready to help if you have a problem, and a community to guide you if you get lost. We must also warn you that Endor can be tough and is not for the faint of heart.

What are you waiting for, are you ready to make a history? Start playing!

The legend continues with you!`,
        
     },
     {
        name: 'UO Evolution',
        slug: 'uo-evolution',
        shards: ['UO Evolution'],
        logo: '/images/logos/server-default.png',
        website: 'https://uoevolution.com/',
        description: 'UO Evolution is an English language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map. Features include no skill cap, custom quests, deep crafting, and a newbie-friendly active community.',
     },
     {
        name: 'UORPG',
        slug: 'uorpg',
        shards: ['UORPG'],
        logo: '/images/logos/server-default.png',
        website: 'https://uorpg.net/',
        description: 'UORPG is a Russian language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map. Features T2A era, stat cap 225, deep crafting, opt-in PvP, and a player-driven economy.',
     },
     {
        name: 'UO Excelsior',
        slug: 'uo-excelsior',
        shards: ['UO Excelsior'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.uoex.net/',
        description: 'UO Excelsior is an English language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with a Custom Map. Features T2A era elements, no skill cap, opt-in PvP, and anti-macro systems.',
     },
     {
        name: 'Pyramid UO',
        slug: 'pyramid-uo',
        shards: ['Pyramid UO'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.pyramiduo.com/',
        description: 'Pyramid UO is a Turkish language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map and stat cap 225.',
     },
     {
        name: 'UO Eventine',
        slug: 'uo-eventine',
        shards: ['UO Eventine'],
        logo: '/images/logos/server-default.png',
        website: 'https://uoeventine.net/',
        description: 'UO Eventine is an English language Ultima Online server featuring PvE gameplay running on the ServUO emulator with a Custom Map. Features no skill cap, custom quests, custom items, newbie-friendly gameplay, and auto events.',
     },
     {
        name: 'Arth UO',
        slug: 'arth-uo',
        shards: ['Arth UO'],
        logo: '/images/logos/server-default.png',
        website: 'https://arthfreeserver.com/',
        description: 'Arth UO is an English language Ultima Online server featuring PvP/PvE gameplay running on the ServUO emulator with the Original Map. Features custom quests, items, deep crafting, and a player economy.',
     },
     {
        name: 'The Crossroads',
        slug: 'the-crossroads',
        shards: ['The Crossroads'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.uocrossroads.net/',
        description: 'The Crossroads is an English language Ultima Online server featuring PvP/PvE gameplay running on the ModernUO emulator with the Original Map. Features opt-in PvP, player housing, and solo-friendly gameplay.',
     },
     {
        name: 'UO Eclipse',
        slug: 'uo-eclipse',
        shards: ['UO Eclipse'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.uoeclipse.com/',
        description: 'UO Eclipse is an English language Ultima Online server featuring PvE gameplay running on the ServUO emulator with a Custom Map. Features T2A era, stat cap 225, custom quests, deep crafting, and auto events.',
     },
     {
        name: 'Beyond Sosaria',
        slug: 'beyond-sosaria',
        shards: ['Beyond Sosaria'],
        logo: '/images/logos/server-default.png',
        website: 'https://beyondsosaria.com/',
        description: 'Beyond Sosaria is an English language Ultima Online server featuring PvE gameplay running on the ServUO emulator with the Original Map. Features no skill cap, custom quests, custom items, deep crafting, and custom pets.',
     },
     {
        name: 'Alathair',
        slug: 'alathair',
        shards: ['Alathair'],
        logo: '/images/logos/server-default.png',
        website: 'https://alathair.de/',
        description: 'Alathair is a German language Ultima Online role-playing server running on the Sphere emulator with a Custom Map. Features custom quests, items, crafting systems, and pet customization.',
     },
     {
        name: 'Classic Dungeon Shard',
        slug: 'classic-dungeon-shard',
        shards: ['Classic Dungeon Shard'],
        logo: '/images/logos/server-default.png',
        website: 'https://cdshard.com/',
        description: 'Classic Dungeon Shard is a Brazilian Portuguese Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map and full loot mechanics.',
     },
     {
        name: 'Tides of Power',
        slug: 'tides-of-power',
        shards: ['Tides of Power'],
        logo: '/images/logos/server-default.png',
        website: 'https://uotides.com/',
        description: 'Tides of Power is an Ultima Online server featuring PvP/PvE gameplay running on the ServUO emulator with a Custom Map. Pre-AoS era with Renaissance and T2A elements, stat cap 225, and an active community.',
     },
     {
        name: 'Ultima Alianza',
        slug: 'ultima-alianza',
        shards: ['Ultima Alianza'],
        logo: '/images/logos/server-default.png',
        website: 'https://ultima-alianza.com/',
        description: 'Ultima Alianza is a Spanish language Ultima Online server featuring PvP gameplay running on the Sphere emulator with the Original Map. Features custom quests, custom pets, and newbie-friendly gameplay.',
     },
     {
        name: 'UODreams',
        slug: 'uodreams',
        shards: ['UODreams'],
        logo: '/images/logos/server-default.png',
        website: 'http://www.uodreams.com/',
        description: 'UODreams is an Italian language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map. Features custom quests, custom items, and active community events.',
     },
     {
        name: 'New Renaissance',
        slug: 'new-renaissance',
        shards: ['New Renaissance'],
        logo: '/images/logos/server-default.png',
        website: 'http://newrenaissanceuo.com/',
        description: 'New Renaissance is an English language Ultima Online server featuring PvP/PvE gameplay running on the ServUO emulator with the Original Map. Pre-AoS era with stat cap 225 and a player-driven economy.',
     },
     {
        name: 'UO Antares',
        slug: 'uo-antares',
        shards: ['UO Antares'],
        logo: '/images/logos/server-default.png',
        website: 'http://bestuo.ru/',
        description: 'UO Antares is a Russian language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map. Features no skill cap, custom quests, custom items, deep crafting, and auto events.',
     },
     {
        name: 'The Miracle',
        slug: 'the-miracle',
        shards: ['The Miracle'],
        logo: '/images/logos/server-default.png',
        website: 'https://themiraclegdr.com/',
        description: 'The Miracle is an Italian language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with a Custom Map. Features custom quests, items, deep crafting, and player housing.',
     },
     {
        name: 'NightUO',
        slug: 'nightuo',
        shards: ['NightUO'],
        logo: '/images/logos/server-default.png',
        website: 'https://nightuo.gen.tr/',
        description: 'NightUO is a Turkish language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map. Pre-AoS Renaissance/T2A era with stat cap 225, anti-macro systems, and donation-free gameplay.',
     },
     {
        name: 'PvP Alfa',
        slug: 'pvp-alfa',
        shards: ['PvP Alfa'],
        logo: '/images/logos/server-default.png',
        website: 'https://pvp-alfa.net/',
        description: 'PvP Alfa is a Russian language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map. Renaissance era with custom pets, fast skill progression, and automated events.',
     },
     {
        name: 'Legends of Sosaria',
        slug: 'legends-of-sosaria',
        shards: ['Legends of Sosaria'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.legendsofsosaria.com/',
        description: 'Legends of Sosaria is an English language Ultima Online server featuring PvE gameplay running on the ServUO emulator with a Custom Map. Features no skill cap, stat cap 225, custom quests, items, and deep crafting. Newbie-friendly and solo-compatible.',
     },
     {
        name: 'Pandora UO',
        slug: 'pandora-uo',
        shards: ['Pandora UO'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.pandorauo.com/',
        description: 'Pandora UO is an Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map. Features custom quests, deep crafting, player housing, and custom pets.',
     },
     {
        name: 'Vetus Mundus',
        slug: 'vetus-mundus',
        shards: ['Vetus Mundus'],
        logo: '/images/logos/server-default.png',
        website: 'https://vetus-mundus.de/',
        description: 'Vetus Mundus is a German language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map. Features custom quests, items, and deep crafting systems.',
     },
     {
        name: 'The Last Kingdom',
        slug: 'the-last-kingdom',
        shards: ['The Last Kingdom'],
        logo: '/images/logos/server-default.png',
        website: 'https://lastkingdom.cz/en',
        description: 'The Last Kingdom is an English language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map. Features no skill cap, newbie-friendly, and fast skill progression.',
     },
     {
        name: 'MIDKEMIA',
        slug: 'midkemia',
        shards: ['MIDKEMIA'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.midkemiauo.com/',
        description: 'MIDKEMIA is a Czech language Ultima Online server featuring PvE gameplay running on the RunUO emulator with a Custom Map. Features custom quests, items, custom pets, and newbie-friendly gameplay.',
     },
     {
        name: 'UO Phoenix',
        slug: 'uo-phoenix',
        shards: ['UO Phoenix'],
        logo: '/images/logos/server-default.png',
        website: 'https://uo-phoenix.com/',
        description: 'UO Phoenix is an English language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with the Original Map. Pre-AoS era with custom quests and opt-in PvP.',
     },
     {
        name: 'UO Strange-Earth',
        slug: 'uo-strange-earth',
        shards: ['UO Strange-Earth'],
        logo: '/images/logos/server-default.png',
        website: 'https://wiki.strange-earth.com/',
        description: 'UO Strange-Earth is an English language Ultima Online server featuring PvP/PvE gameplay running on the ServUO emulator with the Original Map. Features custom quests, items, deep crafting, and custom pets.',
     },
     {
        name: 'Regisfall',
        slug: 'regisfall',
        shards: ['Regisfall'],
        logo: '/images/logos/server-default.png',
        website: 'https://regisfalluo.com/',
        description: 'Regisfall is an English language Ultima Online role-playing server running on the RunUO emulator with a Custom Map. Features stat cap 225, deep crafting, player-driven economy, player housing, and anti-macro systems.',
     },
     {
        name: 'Old Paradise',
        slug: 'old-paradise',
        shards: ['Old Paradise'],
        logo: '/images/logos/server-default.png',
        website: 'https://oldp.net/',
        description: 'Old Paradise is a Russian language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with a Custom Map. Features custom quests, items, deep crafting, and newbie-friendly gameplay.',
     },
     {
        name: 'MythicUO',
        slug: 'mythicuo',
        shards: ['MythicUO'],
        logo: '/images/logos/server-default.png',
        website: 'https://mythic-uo.com/',
        description: 'MythicUO is an English language Ultima Online server featuring PvP/PvE gameplay running on the ServUO emulator with the Original Map. T2A era with stat cap 225, newbie-friendly, and fast skill progression.',
     },
     {
        name: 'UO Resurgence',
        slug: 'uo-resurgence',
        shards: ['UO Resurgence'],
        logo: '/images/logos/server-default.png',
        website: 'http://www.uoresurgence.com/',
        description: 'UO Resurgence is an English language Ultima Online server featuring PvP/PvE gameplay running on the RunUO emulator with a Custom Map. Features no skill cap, custom quests, items, deep crafting, and custom pets.',
     },
     {
        name: 'Horizon',
        slug: 'horizon',
        shards: ['Horizon'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.uohorizon.com/',
        description: 'Horizon is an Ultima Online server featuring PvP/PvE gameplay running on the ServUO emulator with a Custom Map. Features custom quests, items, crafting, pets, and an active community.',
     },
     {
        name: 'Sigena',
        slug: 'sigena',
        shards: ['Sigena'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.uosigena.de/',
        description: 'Sigena is a German language Ultima Online server featuring PvP/PvE gameplay running on the POL emulator with a Custom Map. Features stat cap 225, custom quests, and deep crafting mechanics.',
     },
     {
        name: 'Olmer',
        slug: 'olmer',
        shards: ['Olmer'],
        logo: '/images/logos/server-default.png',
        website: 'https://olmer.su/',
        description: 'Olmer is a Russian language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with a Custom Map. Features custom quests, items, and deep crafting systems.',
     },
     {
        name: 'The Darkside',
        slug: 'the-darkside',
        shards: ['The Darkside'],
        logo: '/images/logos/server-default.png',
        website: 'https://www.tdsshard.com/',
        description: 'The Darkside is an English language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map. Features custom items, deep crafting, fast skills, and hardcore gameplay elements.',
     },
     {
        name: 'Ultima Online XL',
        slug: 'ultima-online-xl',
        shards: ['Ultima Online XL'],
        logo: '/images/logos/server-default.png',
        website: 'https://uoxl.net/',
        description: 'Ultima Online XL is a Russian language Ultima Online server featuring PvP/PvE gameplay running on the Sphere emulator with the Original Map. Features player-driven economy, full loot mechanics, and fast skill progression.',
     },


]

// getServerSkills is kept here until phase 2.3 replaces it with a DB-backed async version.
export const getServerSkills = (server: string) => serverInfo.find(s => s.name === server)?.skills || []


export const getFileTypes = () => [
    'Razor Script (Outlands)',
    'Razor Script (Community Edition)',
    'Razor Enhanced (Python)',
    'Razor Enhanced (C#)',
    'LUA',
    'BASH',
    'CMD',
    'XML',
]

export const SimpleServerSchema = z
	.string({ required_error: 'Server is required' })
	.min(1, 'Server is required')
